import React from "react";

/**
 * Brand social icons (Instagram, Facebook, TikTok, YouTube).
 * Styled to match the PDF: rounded square color tiles with white glyph.
 * Each entry: {key, label, color (gradient or solid bg), Glyph}
 */
const Instagram = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" {...p}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const Facebook = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M13.4 21v-7.6h2.55l.38-2.96H13.4V8.55c0-.86.24-1.45 1.47-1.45h1.57V4.45c-.27-.04-1.2-.12-2.28-.12-2.26 0-3.81 1.38-3.81 3.91v2.18H7.79v2.96h2.56V21h3.05Z" />
  </svg>
);

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.13a8.13 8.13 0 0 0 4.79 1.51v-3.4a4.85 4.85 0 0 1-1.86-.55Z" />
  </svg>
);

const Youtube = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M21.6 7.2a2.6 2.6 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.6 2.6 0 0 0 2.4 7.2 27 27 0 0 0 2 12a27 27 0 0 0 .4 4.8 2.6 2.6 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.6 2.6 0 0 0 1.8-1.8A27 27 0 0 0 22 12a27 27 0 0 0-.4-4.8ZM10 15.2V8.8L15.5 12 10 15.2Z" />
  </svg>
);

export const SOCIAL_BRANDS = [
  {
    key: "instagram",
    label: "Instagram",
    Glyph: Instagram,
    style: {
      background:
        "linear-gradient(135deg, #f9ce34 0%, #ee2a7b 50%, #6228d7 100%)",
    },
  },
  {
    key: "facebook",
    label: "Facebook",
    Glyph: Facebook,
    style: { background: "#1877F2" },
  },
  {
    key: "tiktok",
    label: "TikTok",
    Glyph: TikTok,
    style: { background: "#000000", border: "1px solid #fff" },
  },
  {
    key: "youtube",
    label: "YouTube",
    Glyph: Youtube,
    style: { background: "#FF0000" },
  },
];

/**
 * Inline icon row that picks up URLs from `settings`.
 * Pass `testidPrefix` to namespace data-testids (e.g. 'social' or 'public-social').
 */
export default function SocialIcons({ settings, testidPrefix = "social", iconSize = 22 }) {
  const items = SOCIAL_BRANDS.map((b) => ({
    ...b,
    url: settings?.[`social_${b.key}`] || null,
  }));
  return (
    <div className="flex items-center justify-center gap-3" data-testid={`${testidPrefix}-cta`}>
      {items.map(({ key, label, Glyph, style, url }) => {
        const enabled = !!(url && url.trim());
        const tileCls = "w-12 h-12 rounded-xl flex items-center justify-center transition-all text-white";
        const disabledStyle = { background: "#1a1a1a", border: "1px solid #333", opacity: 0.4 };
        const finalStyle = enabled ? style : disabledStyle;
        return enabled ? (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`${testidPrefix}-${key}`}
            className={`${tileCls} hover:scale-110 hover:shadow-lg`}
            style={finalStyle}
          >
            <Glyph width={iconSize} height={iconSize} />
          </a>
        ) : (
          <span
            key={key}
            data-testid={`${testidPrefix}-${key}-disabled`}
            title={`${label} no configurado aún`}
            aria-label={`${label} (no configurado)`}
            className={`${tileCls} cursor-not-allowed`}
            style={finalStyle}
          >
            <Glyph width={iconSize} height={iconSize} />
          </span>
        );
      })}
    </div>
  );
}
